import { render, staticRenderFns } from "./MovimentItem.vue?vue&type=template&id=5c2e7969&scoped=true&"
import script from "./MovimentItem.vue?vue&type=script&lang=js&"
export * from "./MovimentItem.vue?vue&type=script&lang=js&"
import style0 from "./MovimentItem.vue?vue&type=style&index=0&id=5c2e7969&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e7969",
  null
  
)

export default component.exports